import { Link, useParams } from 'react-router-dom'
import { Stack, Typography } from '@mui/material';
import { artist_name } from '../Player.module.css';


interface InterpretorsNamesProps {
    track: Track,
    defaultNames: string,
}

export const InterpretorsNames = (props: InterpretorsNamesProps) => {
    let { id } = useParams()
    let textColor = props.track && props.track.apple_artwork_bg ? '#'+props.track.apple_artwork_bg : '#ffffff'

    return <Stack spacing={0} direction="row" sx={{ width: '90%', overflow: 'hidden', mb: 1, pb: 0}} alignItems="center">
            <Typography sx={{...artist_name, ...{ color: textColor}}} >
            {
                props.track
                ? 
                props.track.main_artists?.map( (artist: Artist, i: number) =>  {
                    return props.track.main_artists && i === props.track.main_artists?.length - 1
                    ? artist._id === id 
                        ? artist.artist_name
                        : <Link key={i + artist._id} to={`/artist/${artist._id}`} style={{textUnderlineOffset: '3px', color: textColor}}>
                            { artist.artist_name.slice(0, 35) } 
                        </Link>
                    : artist._id === id 
                        ? artist.artist_name + ', ' 
                        : <span key={i + artist._id}>
                            <Link key={i + artist._id} to={`/artist/${artist._id}`} style={{textUnderlineOffset: '3px', color: textColor}}>
                                { artist.artist_name } 
                            </Link>,
                        </span>
                })
                : props.defaultNames
            }
            </Typography>
            { props.track && props.track.featured_artists && props.track.featured_artists.length > 0
                ?
                <>
                <Typography sx={{...artist_name, ...{ color: textColor}}}>&</Typography>
                <Typography sx={{...artist_name, ...{ color: textColor}}}>
                {
                    props.track
                    ? 
                    props.track.featured_artists?.map( (artist: Artist, i: number) =>  {
                        return props.track.featured_artists && i === props.track.featured_artists?.length - 1
                        ? artist._id === id 
                            ? artist.artist_name 
                            : <Link key={i + artist._id} to={`/artist/${artist._id}`} style={{textUnderlineOffset: '3px', color: textColor}}> 
                                { artist.artist_name.slice(0, 35) }
                            </Link>
                        : artist._id === id 
                            ? artist.artist_name + ', ' 
                            : <span key={i + artist._id}>
                                <Link key={i + artist._id} to={`/artist/${artist._id}`} style={{textUnderlineOffset: '3px', color: textColor}}> 
                                    { artist.artist_name.slice(0, 35) } 
                                </Link>, 
                            </span>
                    })
                    : '--'
                }
                </Typography>
                </>
                : ''
            }
        </Stack>
}
